// RenderTablesOptionC.jsx
import React from "react";
import tablecss from "../../css/table.module.css";

/**
 * Props:
 * - data: array of items (your payload)
 * - columnCount: total columns including the first "table-name" column (>=2 recommended)
 * - category: optional string to filter level-1 items by item.category
 *
 * Usage:
 * <RenderTablesOptionC data={myData} columnCount={3} category="BS" />
 */
export default function RenderBSPLTables({
  data,
  columnCount = 3,
  category = null,
  notesCount = 0,
  templateData,
  onNoteClick,
  selectedIndex = null,
}) {
  const cols = Math.max(1, Number(columnCount) || 3);
  // header will be: [ tableNameHeader, C1, C2, ... ] but tableNameHeader is the actual tableItem.name per row
  const cHeaders = Array.from({ length: cols - 1 }, (_, i) => `C${i + 1}`);

  // filter level-1 items and optionally by category
  const level1Items = Array.isArray(data)
    ? data.filter(
        (d) =>
          d.level === 1 &&
          (category == null || d.category === category)
      )
    : [];

  return (
    <>
      {level1Items.map((tableItem, ti) => {
        const absoluteIdx = Array.isArray(data) ? data.indexOf(tableItem) : -1;
        return (
          <div
            key={tableItem._id || tableItem.id || `tbl-${ti}`}
            id={absoluteIdx !== -1 ? `table-${absoluteIdx}` : `table-${ti}`}
            className={tablecss.tableContainer}
            style={{
              border: "1px solid #CCD5D3",
              borderRadius: "8px",
              overflow: "hidden",
              marginBottom: "16px",
              scrollMarginTop: "20px",
            }}
          >
          <table
            key={`tbl-${ti}-${tableItem.name}`}
            className={tablecss.customTable}
            style={{ borderCollapse: "collapse", width: "100%" }}
          >
            {/* HEADER: first column shows the actual table name for this table */}
            <thead>
              <tr style={{ textAlign: "left" }}>
                <th
                  style={{
                    padding: "20px 12px",
                    fontWeight: "bold",
                    backgroundColor: "#EFF7F0",
                    width: "300px",
                  }}
                >
                  {tableItem.name}
                </th>

                <th
                  style={{
                    padding: "10px 12px",
                    backgroundColor: "#EFF7F0",
                    textAlign: "center",
                  }}
                >
                  Notes
                </th>
                <th
                  style={{
                    padding: "10px 12px",
                    backgroundColor: "#EFF7F0",
                    textAlign: "right",
                  }}
                >
                  As on DD-MM-YYYY
                </th>
                <th
                  style={{
                    padding: "10px 12px",
                    backgroundColor: "#EFF7F0",
                    textAlign: "right",
                  }}
                >
                  As on DD-MM-YYYY
                </th>
              </tr>
            </thead>

            <tbody>
              {/* Level 2 rows */}
              {Array.isArray(tableItem.subgroup) &&
              tableItem.subgroup.length > 0 ? (
                tableItem.subgroup.map((l2, idx) => {
                const notesData =
                  category === "BS"
                    ? templateData?.BSNotes
                    : templateData?.PLNotes;

                const noteObj = notesData?.find(
                  (n) => n.groupingID === l2._id
                );

                return ( 
                  <React.Fragment key={`l2-${idx}-${l2.name}`}>
                    <tr>
                      <td style={{ padding: "10px 12px" }}>{l2.name}</td>
                      <td style={{ textAlign: "center", padding: "10px 12px" }}>
                        {noteObj?.notes ? (
                          <span
                            style={{
                              color: "#205a46",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                            onClick={() => onNoteClick && onNoteClick({ ...noteObj, l2Name: l2.name }, category)}
                          >
                            {noteObj.notes}
                          </span>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td style={{ textAlign: "right", padding: "10px 12px" }}>-</td>
                      <td style={{ textAlign: "right", padding: "10px 12px" }}>-</td>
                    </tr>
                  </React.Fragment>
                );
              })
              ) : (
                // no subgroup rows
                <tr>
                  <td
                    style={{ padding: "10px 12px", color: "#6b7280" }}
                    colSpan={cols}
                  >
                    <em>No Level 2 or Level 3 items.</em>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      );
    })}
  </>
  );
}
